import CartItemsView from '../../views/library/cart-items.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IPerformance, IPerformanceGroup, IPackage } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state/index';
import { removeItemFromCart } from '../../redux-state/actions/package-listing.actions';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';


interface ICartItemsExternalProps {
    packageMax: number;
    packageMin: number;
    performanceGroups: Array<IPerformanceGroup>;
}

interface StateToProps {
    cartItems: Map<number, number>;
    itemsInCart: number;
    text: IPackageListingAppText;
    requiresPerformanceGroups: boolean;
    isFixedPackage: boolean;
}

interface DispatchToProps {
}

export interface CartItemGroupViewProps {
    groupName: string;
    groupId: number;
    text: IPackageListingAppText;
    performanceMin: number;
    cartItems: Map<number, number>;
    isFixedPackage: boolean;
}
export type CartItemsProps = ICartItemsExternalProps & StateToProps & DispatchToProps;


export class CartItemsBase extends React.Component<CartItemsProps, any> {
    constructor(props: CartItemsProps) {
        super(props);
    }

    render() {
        return <CartItemsView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: ICartItemsExternalProps): StateToProps {

    return {
        requiresPerformanceGroups: ownProps.performanceGroups.length > 1
            && ownProps.performanceGroups
                .filter(pg => pg.minimumPerformances > 0 ||
                    (pg.maximumPerformances > 0 && pg.maximumPerformances != ownProps.packageMax)).length > 0,
        text: state.packageListingText,
        isFixedPackage: state.packageListingSettings.isFixed,
        cartItems: state.packageListing.cartItems,
        itemsInCart: state.packageListing.cartItems.size 
    }
}

function mapDispatchToProps(dispatch, ownProps: CartItemsProps): DispatchToProps {
    return {


    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(CartItemsBase);